import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function LangToggle() {
  const { lang, toggleLang } = useLanguage();
  return (
    <button type="button" className="lang-toggle" onClick={toggleLang}>
      {lang === 'en' ? 'తె' : 'EN'}
    </button>
  );
}
